const history = {
  title: 'Meus Projetos',
  upgradeBtn: 'Atualizar',
  subTitle:
    'Não se esqueça de baixar seu arquivo, pois ele será apagado após 72 horas.',
  MAgo: '{{num}} minutos atrás',
  HAgo: '{{num}} minutos atrás',
  DAgo: '{{num}} day ago',
  justNow: 'Agora mesmo',
  originalFile: 'Arquivo original',
  selectAllBtn: 'Selecionar todos',
  emptyTips: 'Nenhum projeto ainda. <1>Ir editar</1>',
  deleteTips: 'Tem certeza que deseja deletar?',
};

export default history;
